import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/zap.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M12.2316 1.35926C12.5158 1.01835 12.9915 0.906153 13.3986 1.08289C13.8056 1.25977 14.0474 1.68357 13.9924 2.12391L13.133 8.99989H19.2922C19.5444 8.99988 19.8027 8.99856 20.0119 9.01746C20.2004 9.03454 20.562 9.07995 20.8752 9.33289C21.2337 9.62262 21.4397 10.0614 21.4328 10.5223C21.4267 10.925 21.2299 11.2318 21.1222 11.3876C21.0028 11.5604 20.8365 11.7582 20.675 11.952L11.7687 22.6405C11.4845 22.9815 11.0089 23.0936 10.6017 22.9169C10.1946 22.7401 9.95293 22.3163 10.008 21.8759L10.8674 14.9999H4.70818C4.45568 14.9999 4.19678 15.0013 3.98747 14.9823C3.79888 14.9652 3.43816 14.9196 3.12517 14.6669C2.76663 14.3771 2.56065 13.9383 2.56755 13.4774L2.57829 13.3309C2.62143 13.0004 2.78392 12.7485 2.8781 12.6122C2.99751 12.4393 3.16381 12.2416 3.32536 12.0477L12.2316 1.35926ZM5.13493 12.9999H12.0002C12.2869 12.9999 12.5604 13.1228 12.7502 13.3378C12.94 13.5528 13.0279 13.8393 12.9924 14.1239L12.4152 18.7382L18.8654 10.9999H12.0002C11.7134 10.9999 11.44 10.877 11.2502 10.662C11.0603 10.447 10.9724 10.1605 11.008 9.87586L11.5842 5.26063L5.13493 12.9999Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ZapIcon };
